import React, { Suspense } from 'react'
import { useSelector } from 'react-redux'

import { ErrorBoundary, Loader } from 'components/atoms'
import { AtterrissageTable } from 'components/sections/Analyse/AtterrissageTable'
import { getPerimetre } from 'store/analyse'

export const AnalysePageAtterrissage: React.FC = () => {
  const perimetre = useSelector(getPerimetre)

  if (!perimetre || perimetre.length === 0) return null

  return (
    <div css={{ position: 'relative', minHeight: 100 }}>
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <AtterrissageTable />
        </Suspense>
      </ErrorBoundary>
    </div>
  )
}
